import { FormGroup } from "@angular/forms";
import { FormlyView } from "../FormlyView";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { MeddraLevel } from "../../Node/MeddraNode/MeddraNode";

export class MeddraTerm extends FormlyView {

    // JMBL meddraLevel!:MeddraLevel;

    constructor(
        fields:FormlyFieldConfig[],
        item:any
    ) {
        super( new FormGroup({}), 
            [...fields], item);
    }
}